  @let _layers = layers();


<app-accordion collapsible="true">
  <app-accordion-item [heading]="accordionHeader">
    <span>Opacity:{{ opacityLabel() }}</span>
    <esk-slider
      [min]="0"
      [max]="100"
      [ngModel]="opacity()"
      (ngModelChange)="setLayerGroupOpacity($event)"
    ></esk-slider>

    @if (_layers.length > 0) {
    <article class="layer-group_layers">
      @for (layer of _layers; track layer) {
      <app-layer [layer]="layer"></app-layer>
      }
    </article>
    } @for (layerGroup of layerGroups(); track layerGroup) {
    <app-layer-group [layerGroup]="layerGroup"></app-layer-group>
    }
  </app-accordion-item>
</app-accordion>

<ng-template #accordionHeader>
  <esk-switch
    (click)="$event.stopPropagation()"
    [ngModel]="visible()"
    (ngModelChange)="setLayerGroupVisibility($event)"
  ></esk-switch>
  {{ layerGroup().get('title') }}
</ng-template>
